var _defs, _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPolygon = function SvgPolygon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12.59 11.02",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#624d9d;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "\u8D44\u6E90 1")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.52,3.38a.78.78,0,0,0-.78,0l-1.82,1-1.25.72-1.82,1a.78.78,0,0,1-.78,0L1.64,5.38a.78.78,0,0,1-.4-.68V3.05a.78.78,0,0,1,.4-.68l1.43-.83a.78.78,0,0,1,.78,0l1.43.83a.79.79,0,0,1,.39.68V4.11l1.25-.72V2.33a.79.79,0,0,0-.39-.68L3.85.11a.73.73,0,0,0-.78,0L.39,1.65A.79.79,0,0,0,0,2.33V5.42a.79.79,0,0,0,.39.68L3.07,7.64a.78.78,0,0,0,.78,0l1.82-1,1.25-.72,1.82-1a.78.78,0,0,1,.78,0L11,5.64a.78.78,0,0,1,.4.68V8a.78.78,0,0,1-.4.68l-1.43.83a.78.78,0,0,1-.78,0L7.31,8.65A.79.79,0,0,1,6.92,8V6.91l-1.25.72V8.69a.78.78,0,0,0,.4.68l2.67,1.55a.78.78,0,0,0,.78,0L12.2,9.37a.79.79,0,0,0,.39-.68V5.6a.8.8,0,0,0-.39-.68Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPolygon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/polygon.eb0fd77a.svg";
export { ForwardRef as ReactComponent };